var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["children", "overwriteHeadingStyles", "className", "more", "less"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import classNames from "classnames";
import { ExpandableText } from "../text/Text";
import { expandableMarkdownCls, expandableMarkdownOverwriteHeadingCls } from "./Markdown.less";
var ExpandableMarkdown = /* @__PURE__ */ __name(function ExpandableMarkdown2(_ref) {
  var children = _ref.children, _ref$overwriteHeading = _ref.overwriteHeadingStyles, overwriteHeadingStyles = _ref$overwriteHeading === void 0 ? true : _ref$overwriteHeading, className = _ref.className, more = _ref.more, less = _ref.less, props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ React.createElement(ExpandableText, _extends({
    customClassName: classNames(expandableMarkdownCls, overwriteHeadingStyles && expandableMarkdownOverwriteHeadingCls, className),
    more,
    less,
    isMarkdown: true
  }, props), children);
}, "ExpandableMarkdown");
export {
  ExpandableMarkdown
};
